<div class="quick-search">
    <aa-quick-search-word
        [storageKey]="'/admin/impersonate/popin/user'"
        (qsWordChanged)="onQsWordChanged($event)"
    ></aa-quick-search-word>
</div>
<div class="multi-zone"
     *ngIf="isEmpty | async">
    <aa-lack-of-data [title]="'ADMIN.LIST.LACKOFDATA.TITLE' | translate"
                     [message]="">
    </aa-lack-of-data>
</div>
<div class="multi-zone"
     *ngIf="!(isEmpty | async)">
    <div class="virtual-scrollable-viewport aa-scrollable-y aa-scrollbar">
        <aa-user-card
            *ngFor="let user of users | async; let idx = index"
            [user]="user"
            [withRoles]="true"
            [cta]="onSelect"
            [impePopin]="true"
        >
        </aa-user-card>
    </div>
</div>